var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12968_27821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1556 1.93921H10.4685V0H5.56226V1.93921H1.875V5.2301H2.57813V16H13.4526V5.2301H14.1556V1.93921ZM6.49976 0.9375H9.53101V1.93921H6.49976V0.9375ZM2.8125 2.87671H13.2181V4.2926H2.8125V2.87671ZM12.5151 15.0625H3.51563V5.2301H12.5151V15.0625Z",
    fill: "#FF5A5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.54663 7.06836H8.48413V13.2246H7.54663V7.06836Z",
    fill: "#FF5A5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80811 7.06836H10.7456V13.2246H9.80811V7.06836Z",
    fill: "#FF5A5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.28491 7.06836H6.22241V13.2246H5.28491V7.06836Z",
    fill: "#FF5A5F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12968_27821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.b86688b0663cf6e285d31b6d08ae36c4.svg";
export { ForwardRef as ReactComponent };